import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import { Input } from './Input';

const validCharacterInput = /[a-zA-Z0-9-]/;

export function SlugInput(props: {
  label: string;
  name: string;
  url: string;
  slugPrefix?: string;
  slugSuffix?: string;
  editMode?: boolean;
}) {
  const { setValue, watch } = useFormContext();
  const value = watch(props.name);

  const cleanSlug = (e: any) => {
    let slug = e.target.value;
    if (slug[slug.length - 1] === '-') {
      slug = slug.slice(0, -1);
    }
    setValue(props.name, slug.toLowerCase());
  };
  return (
    <Input
      label={props.label}
      name={props.name}
      className={classNames(
        !props.editMode && 'pointer-events-none bg-gray-100 border-l-2',
      )}
      leftText={
        <span data-test-id="link-prefix">
          {props.url}/{props.slugPrefix ? `${props.slugPrefix}` : ''}
          {props.slugSuffix && props.slugPrefix ? '-' : ''}
        </span>
      }
      onBlur={cleanSlug}
      onKeyDown={(e) => {
        if (!validCharacterInput.test(e.key)) {
          e.preventDefault();
        }
        if (e.key === 'Enter') {
          cleanSlug(e);
        }
        const selectionStart = e.currentTarget.selectionStart;
        if (e.key === '-' && selectionStart !== null) {
          const slug = value;
          if (
            slug[selectionStart - 1] === '-' ||
            slug[selectionStart] === '-' ||
            selectionStart === 0
          ) {
            e.preventDefault();
          }
        }
      }}
      onSubmit={cleanSlug}
      data-test-id="link-suffix-input"
    />
  );
}
